import { motion } from 'framer-motion';
import { Brain } from 'lucide-react';

// V2 AI Observations — mentor-style pattern lines (best day, top blocker, last learning).
// Renders below GrowthCards.
export default function AIObservations({ items }) {
  if (!Array.isArray(items) || items.length === 0) return null;
  return (
    <div className="mt-4" data-testid="ai-observations">
      <div className="flex items-center gap-2 mb-2 pl-1">
        <Brain size={14} color="#7E5BEF" strokeWidth={3} />
        <p className="text-[10px] uppercase font-extrabold text-[#7E5BEF] tracking-wider">
          What your mentor noticed
        </p>
      </div>
      <div className="space-y-2">
        {items.map((it, idx) => (
          <motion.div
            key={it.id}
            initial={{ opacity: 0, x: -6 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.25, delay: 0.05 * idx }}
            className="gm-card p-3 flex items-start gap-3"
            data-testid={`ai-observation-${it.id}`}
          >
            <div className="w-9 h-9 rounded-2xl bg-[#7E5BEF]/10 flex items-center justify-center text-xl flex-shrink-0">
              <span aria-hidden>{it.emoji}</span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-extrabold text-[#1F2937] leading-snug">
                {it.title}
              </p>
              <p className="text-xs font-bold text-[#4B4B4B] leading-snug mt-1">
                {it.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
